import { getRedirectParamsFromCookie } from '@/utils/localStorage';
import { getDeepLinkProtocol } from '@/utils/platform';

import { resolveDeepLinkProtocol } from './deep-link-protocol';
import {
  appendLoginBrowserAttribution,
  type LoginBrowserAttribution,
} from './login-browser-attribution';

import type { TokenExchangeResponse } from './types';

export function extractProtocolFromOauthState(state: string): string | null {
  if (!state) return null;
  const lastHyphenIndex = state.lastIndexOf('-');
  return lastHyphenIndex !== -1 ? state.substring(0, lastHyphenIndex) : null;
}

export function buildDesktopCallbackUrl(options: {
  params: Record<string, string>;
  tokenResponse?: TokenExchangeResponse;
  deepLinkProtocol?: string;
  loginBrowserAttribution?: LoginBrowserAttribution;
  loginAttempt?: string;
}): string {
  const {
    params,
    tokenResponse,
    deepLinkProtocol,
    loginBrowserAttribution,
    loginAttempt,
  } = options;

  const protocolSchema =
    resolveDeepLinkProtocol(deepLinkProtocol) ??
    resolveDeepLinkProtocol(
      extractProtocolFromOauthState(params.state || '')
    ) ??
    getDeepLinkProtocol();

  if (tokenResponse) {
    const redirectParams = getRedirectParamsFromCookie();
    const tokenParams = new URLSearchParams({
      ...redirectParams,
      access_token: tokenResponse.access_token,
      refresh_token: tokenResponse.refresh_token,
      id_token: tokenResponse.id_token,
      expires_in: tokenResponse.expires_in.toString(),
    });
    appendLoginBrowserAttribution(tokenParams, loginBrowserAttribution);
    // Set after the cookie spread so a `redirectParams` entry can never override it
    if (loginAttempt !== undefined) {
      tokenParams.set('login_attempt', loginAttempt);
    }
    return `${protocolSchema}://auth-callback?${tokenParams.toString()}`;
  }

  return `${protocolSchema}://auth-callback?${new URLSearchParams(params)}`;
}
